import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0e357d13"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "app-validate-form" };
const _hoisted_2 = { class: "app-validate-form__group" };
const _hoisted_3 = { for: "pin" };
const _hoisted_4 = ["placeholder"];
const _hoisted_5 = { class: "app-validate-form__group" };
const _hoisted_6 = { for: "token" };
const _hoisted_7 = { class: "app-validate-form__actions" };
import { useAppAuth } from '@/features/Login360/app/composables';
import router from '@/router';
import { computed, onMounted, reactive } from 'vue';
import { useMixpanelConfig } from '@/utilities/mixpanel';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AppValidateForm',
    setup(__props) {
        const { loading, validateLogin } = useAppAuth();
        const validateForm = reactive({ pin: '', token: '' });
        const disableSubmit = computed(() => !validateForm.pin || !validateForm.token);
        async function submit() {
            await validateLogin(validateForm.pin, validateForm.token);
        }
        function gotoAnalytics() {
            router.push({ name: 'login' });
        }
        onMounted(() => {
            useMixpanelConfig('view_migration360_seller_form');
        });
        return (_ctx, _cache) => {
            const _component_el_input = _resolveComponent("el-input");
            const _component_el_button = _resolveComponent("el-button");
            return (_openBlock(), _createElementBlock("form", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('login360.validate.pin.label')), 1),
                    _withDirectives(_createElementVNode("input", {
                        id: "pin",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((validateForm.pin) = $event)),
                        placeholder: _ctx.$t('login360.validate.pin.placeholder'),
                        required: "",
                        type: "text"
                    }, null, 8, _hoisted_4), [
                        [_vModelText, validateForm.pin]
                    ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('login360.validate.token.label')), 1),
                    _createVNode(_component_el_input, {
                        id: "token",
                        modelValue: validateForm.token,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((validateForm.token) = $event)),
                        placeholder: _ctx.$t('login360.validate.token.placeholder'),
                        "show-password": "",
                        type: "password"
                    }, null, 8, ["modelValue", "placeholder"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_el_button, {
                        disabled: disableSubmit.value,
                        loading: _unref(loading),
                        "native-type": "submit",
                        round: "",
                        onClick: _withModifiers(submit, ["prevent"])
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('login360.validate.nextButton')), 1)
                        ]),
                        _: 1
                    }, 8, ["disabled", "loading", "onClick"]),
                    _createVNode(_component_el_button, {
                        round: "",
                        onClick: gotoAnalytics
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('login360.validate.gotoAnalytics')), 1)
                        ]),
                        _: 1
                    })
                ])
            ]));
        };
    }
});
